import React from 'react';
import { motion } from 'framer-motion';
import { RepHeader } from '../RepHeader';
import { repConfig } from '../../../config';
import { CheckCircle2, MessageSquare } from '../../ui/Icons';
import { Button } from '../../ui/Button';

export function StepConfirm({ data }) {
  return (
    <div className="w-full max-w-2xl mx-auto flex flex-col items-center text-center space-y-4 md:space-y-10 py-4 md:py-12 overflow-y-auto max-h-full">
      <motion.div 
        initial={{ scale: 0, rotate: -45 }} 
        animate={{ scale: 1, rotate: 0 }} 
        transition={{ type: "spring", damping: 15, stiffness: 200, delay: 0.2 }}
        className="w-16 h-16 md:w-24 md:h-24 bg-green-500/20 rounded-full flex items-center justify-center text-green-400 shrink-0"
      >
        <CheckCircle2 size={32} className="md:w-12 md:h-12" />
      </motion.div>

      <div className="space-y-2 md:space-y-4">
        <h1 className="font-heading text-2xl md:text-5xl font-bold px-2">
          You're all set, {data.firstName}!
        </h1>
        <p className="text-sm md:text-xl text-gray-400 max-w-lg mx-auto px-4 leading-relaxed">
          {repConfig.name} will personally reach out within the next 15 minutes to walk you through your matches.
        </p>
      </div>

      <div className="w-full px-2">
        <RepHeader variant="large" />
      </div>

      <div className="bg-white/5 border border-white/10 rounded-2xl p-4 md:p-6 w-full space-y-3 md:space-y-4 mb-4">
        <div className="space-y-1">
          <h4 className="font-semibold text-base md:text-lg">Skip the wait</h4>
          <p className="text-gray-400 text-[11px] md:text-sm">Send a quick text to let {repConfig.name} know you just submitted your preferences.</p>
        </div>
        <a 
          href={`sms:${repConfig.phoneClean}?body=Hi ${repConfig.name}, I just completed your vehicle search quiz online!`} 
          className="block w-full"
        >
          <Button variant="secondary" className="w-full bg-white/10 hover:bg-white/20 h-11 md:h-14">
            <MessageSquare size={16} className="md:w-5 md:h-5" /> Text {repConfig.name} Directly
          </Button>
        </a>
      </div>
    </div>
  );
}